import React, { useEffect, useState } from "react";
// import Progress from "../Progress";
import "../ContentPages/style.css";
import SubmitButton from "../Buttons/SubmitButton";
import { useForm } from "react-hook-form";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";
import { AppContext } from "../../contexts/AppContext";
import { getMetadataKeyByValue } from "../../Utils/metaData";
import { useNavigate } from "react-router-dom";
import { getApplication } from "../../Services/applicationService.jsx";
import { redirectToRealMe } from "../../Services/apiService";
import ExternalLink from "../ExternalLink/ExternalLink.tsx";
import Loader from "../Loader/Loader.jsx";
import {
  getCountryNameById,
  getLabelFromId,
} from "../../Services/localStorage.tsx";

const SavedApplication = ({ handleNext, handleBack }) => {
  const { appState, userFlows } = React.useContext(AppContext);
  const [applicationStatus, setApplicationStatus] = React.useState(null);
  const [addressCountryLabel, setAddressCountryLabel] = useState("");

  const navigate = useNavigate();

  const applicationId = appState?.requestPayload?.applicationId || null;
  const savedApplication = appState?.requestPayload?.applicant || {};

  useEffect(() => {
    const fetchSavedApplication = async () => {
      if (applicationId) {
        try {
          const response = await getApplication(applicationId);
          // console.log("Saved Application Data:", response.summary);
          const details = JSON.parse(
            response.summary.applicationDetails || "{}",
          );
          // console.log("Parsed Details:", details);
          // const applicationData = JSON.parse(
          //   response.details.json || "{}"
          // )
          // console.log("Parsed Application Data:", applicationData);
          setApplicationStatus(details.status || null);

          getCountryNameById(
            appState?.requestPayload?.applicant?.countryOfBirthId,
          ).then((countryName) => {
            setAddressCountryLabel(countryName);
          });

          // Update the appState with the fetched data
          // Assuming you have a function to update the appStat
        } catch (error) {
          console.error("Error fetching saved application:", error);
          navigate("/app/something-went-wrong");
        }
      }
    };
    fetchSavedApplication();
  }, [applicationId, navigate]);

  const { handleSubmit } = useForm();

  const onSubmit = (data) => {
    // console.log(data);

    const applicationFlowCode = appState?.requestPayload?.applicationFlowCode;
    //check if apply
    let eventTypeId;
    if (applicationFlowCode === 100000000) {
      eventTypeId = appState?.requestPayload?.eventTypeSearch?.[0]?.eventTypeId;
    } else if (applicationFlowCode === 100000001) {
      eventTypeId = applicationFlowCode;
    }

    if (applicationFlowCode === 100000000) {
      let livenessStatusCode =
        appState?.requestPayload?.liveness?.livenessStatusCode;
      let photoShop = "photoShop" in appState?.requestPayload;

      // referee data is not provided if date of birth is 9999-01-01,
      // this is check we are leaving in place for ongoing applications before we have implemented hasRefereeData field
      let noRefereeData =
        appState?.requestPayload?.referee?.dateOfBirth === "9999-01-01";
      let hasRefereeData = appState?.requestPayload?.hasRefereeData;

      if (photoShop) {
        navigate("/app/photo-id");
        return;
      }

      if (hasRefereeData === false || noRefereeData) {
        navigate("/app/pre-referee");
        return;
      }

      if (livenessStatusCode === 100000000) {
        if (userFlows?.showLiveness === false) {
          navigate("/app/photo-id");
          return;
        }
        navigate("/app/pre-live-check");
        return;
      }

      if (livenessStatusCode === 100000002) {
        navigate("/app/post-live-check");
        return;
      }
    }

    // console.log("Event Type ID:", eventTypeId);
    switch (eventTypeId) {
      case "527c00ad-5756-ed11-9562-002248941c78":
        // Do something for NZ travel document
        navigate("/app/passport");
        break;

      case "b9294e90-bcd5-ee11-904c-000d3acb9d09":
        // Do something for Foreign Passport
        navigate("/app/immigration");
        break;

      case "2dad80bb-5756-ed11-9562-002248941c78":
        // Do something for NZ Citizenship
        navigate("/app/citizenship");
        break;

      case "700a9fae-a634-ed11-9db1-0022489412bc":
        navigate("/app/birth-certificate");
        break;

      case "381eb874-1533-e911-a855-000d3ae09197":
        navigate("/app/birth-certificate");
        break;

      case 100000001:
        navigate("/app/renew-identity");
        break;

      default:
        // Handle unknown or null eventTypeId
        break;
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    try {
      const options = { day: "numeric", month: "long", year: "numeric" };
      return new Date(dateStr).toLocaleDateString("en-NZ", options); // 27 April 1948
    } catch {
      return dateStr;
    }
  };

  if (!applicationStatus) {
    return <Loader />;
  }
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="intro">
          {/* <Progress progress={40} /> */}
          <h1 className="intro-title-mi" lang="mi-NZ">
            {applicationStatus === "Draft"
              ? "Tono kua tiakina"
              : "E tāria ana te hāponotanga"}
          </h1>
          <hr />
          <h1 className="intro-title">
            {applicationStatus === "Draft"
              ? "Saved application"
              : "Pending verification"}
          </h1>

          <div className="step-container">
            {applicationStatus === "Waiting on photo shop visit" ? (
              <h2 className="step-title mb-2">
                Complete your application at a RealMe partner store
              </h2>
            ) : (
              <h2 className="step-title mb-2">
                {" "}
                {applicationStatus === "Draft"
                  ? "An application is in progress"
                  : "Your application is being processed"}
              </h2>
            )}
            {applicationStatus === "Waiting on photo shop visit" ? (
              <React.Fragment>
                <p className="mb-4">
                  You need to visit a{" "}
                  <a
                    href="https://www.realme.govt.nz/how-apply/find-participating-photostore/"
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    RealMe partner store
                  </a>{" "}
                  to complete your application.
                </p>
                <p className="mb-4">
                  We've sent an email to{" "}
                  <strong>
                    {" "}
                    {appState.requestPayload.applicant.emailAddress}
                  </strong>{" "}
                  with instructions of what you need to bring.
                </p>

                <p className="mb-4">
                  If you have any questions,{" "}
                  <ExternalLink
                    href="https://www.realme.govt.nz/contact-us/"
                    text="contact us."
                  />
                </p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {applicationStatus === "Draft" ? (
                  <React.Fragment>
                    <p className="mb-4">
                      You have previously started an application which is saved.
                      These details will be saved for 30 days.
                    </p>
                    {/* <h3 className="step-title mb-2">To be completed</h3>
                <div className="info">
                  <img src={InfoIcon} alt="Info" />
                  To submit your application, you must complete all sections
                  below.
                </div>
                <div className="step-container-nospace">
                  {!appState?.requestPayload?.liveness?.livenessResult && (
                    <div className="step-container-box">
                      <p className="label">Tell us about any changes</p>
                    </div>
                  )}
                  {(!appState?.requestPayload?.liveness?.livenessResult && (appState?.requestPayload?.supportingInformation
              ?.nameChangeSourceCode <= 100000003) && new Date(
                appState?.requestPayload?.eventTypeSearch?.[1]?.dateOfEvent
              ) > new Date("2009-01-01")) && (
                    <div className="step-container-box">
                      <p className="label">Photo verification</p>
                    </div>
                  )}

                  <div className="step-container-box">
                    <p className="label">Referee</p>
                  </div>
                </div> */}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <p className="mb-4">
                      We're processing your application. Check our website for
                      current processing times.
                    </p>
                    <p className="mb-4">
                      <ExternalLink
                        href="https://www.realme.govt.nz/help/#how-long-does-it-take-to-get-a-realme-verified-identity/"
                        text="RealMe — How long it takes to get a verified identity"
                      />
                    </p>
                    <p className="mb-4">
                      We'll contact you if we need more information. When your
                      verified identity is ready to use, we'll send an email to{" "}
                      <strong>
                        {appState.requestPayload.applicant.emailAddress}
                      </strong>
                      .
                    </p>
                    <p className="mb-4">
                      If you have any questions,{" "}
                      <ExternalLink
                        href="https://www.realme.govt.nz/contact-us/"
                        text="contact us."
                      />
                    </p>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}

            <div className="step-container">
              <h2 className="step-title mb-2">Your application details</h2>
              <div className="step-container-box">
                <p className="label">Application number</p>
                <p className="value">{applicationId}</p>
              </div>
              <div className="step-container-box">
                <p className="label">Full name</p>
                <p className="value">
                  {savedApplication.givenNames +
                    " " +
                    savedApplication.familyName}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Date of birth</p>
                <p className="value">
                  {formatDate(savedApplication.dateOfBirth)}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Place of birth</p>
                <p className="value">
                  {savedApplication.placeOfBirth}, {addressCountryLabel}
                </p>
              </div>
              <div className="step-container-box">
                <p className="label">Gender</p>
                <p className="value">
                  {getMetadataKeyByValue(
                    "GenderReference",
                    savedApplication.genderId,
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="step-button-container">
          {applicationStatus === "Draft" ? (
            <SubmitButton text={"Continue application"} type="submit" />
          ) : (
            <SubmitButton
              text={"Back to RealMe"}
              onClick={redirectToRealMe}
              type="button"
              Icon={BackIconWhite}
            />
          )}
          {/* <BackButton text={"Back"} onClick={handleBack} /> */}
        </div>
      </form>
    </>
  );
};

export default SavedApplication;
